<template>
  <div class="stage">
    <div class="control-width mx-auto">
      <div class="p-4 p-md-5 border shadow-sm add-rounded">
        <h4 class="mb-4 font-weight-bold text-capitalize kova-text">
          Project Onboarding
        </h4>
        <h6 class="mb-3 font-weight-bold">
          What type of job do you need talent for?
        </h6>

        <!-- <label for="opt1" class="radio text-left">
                    <input type="radio" name="rdo" id="opt1" class="hidden"/>
                    <span class="label"></span>New Project
                </label><br />
                
                <label for="opt2" class="radio text-left">
                    <input type="radio" name="rdo" id="opt2" class="hidden"/>
                    <span class="label"></span>Ongoing Project
                </label><br />
        <hr />-->
        <div class="container-fluid px-0 px-md-4 mb-5">
          <div class="row my-5">
            <div class="col-6 mx-auto px-1 px-sm-3 px-md-4">
              <div
                class="border stage-box d-flex align-items-center mx-auto"
                @click="clickedFulltimeJob"
              >
                <h6 class="kova-text font-weight-bolder mx-auto">
                  Full-time job role
                </h6>
                <font-awesome-icon
                  icon="check-circle"
                  class="checked"
                  v-if="fulltimeJob"
                ></font-awesome-icon>
              </div>
            </div>

            <div class="col-6 mx-auto px-1 px-sm-3 px-md-4">
              <div
                class="border stage-box d-flex align-items-center mx-auto"
                @click="clickedContractJob"
              >
                <h6 class="kova-text font-weight-bolder mx-auto">
                  Contract job role
                </h6>
                <font-awesome-icon
                  icon="check-circle"
                  class="checked"
                  v-if="contractJob"
                ></font-awesome-icon>
              </div>
            </div>
          </div>
          <div class="row my-5">
            <div class="col-6 px-1 px-sm-3 px-md-4">
              <div
                class="border stage-box d-flex align-items-center mx-auto"
                @click="clickedCuratedJob"
              >
                <h6 class="kova-text font-weight-bolder mx-auto">
                  Curated job
                </h6>
                <font-awesome-icon
                  icon="check-circle"
                  class="checked"
                  v-if="curatedJob"
                ></font-awesome-icon>
              </div>
            </div>
          </div>
          <!-- <div class="row my-5">
            <div class="col-6 mx-auto px-1 px-sm-3 px-md-4">
              <div
                class="border stage-box d-flex align-items-center mx-auto"
                @click="clickedFreelanceJob"
              >
                <h6 class="kova-text font-weight-bolder mx-auto">Freelance job</h6>
                <font-awesome-icon icon="check-circle" class="checked" v-if="freelanceJob"></font-awesome-icon>
              </div>
            </div>
            <div class="col-6 mx-auto px-1 px-sm-3 px-md-4">
              <div
                class="border stage-box d-flex align-items-center mx-auto"
                @click="clickedCrowdsourceJob"
              >
                <h6 class="kova-text font-weight-bolder mx-auto">Crowdsource Project</h6>
                <font-awesome-icon icon="check-circle" class="checked" v-if="crowdsourceJob"></font-awesome-icon>
              </div>
            </div>
          </div> -->

          <div class="row">
            <div class="col text-left">
              <button
                class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded"
                v-on:click="goBack"
              >
                Back
              </button>
            </div>
            <div class="col text-right">
              <button
                class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded"
                v-on:click="next"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right kova-text pt-3 mr-4">
        <!--  <span @click="skip">
          Skip
          <font-awesome-icon icon="step-forward"></font-awesome-icon>
        </span>-->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "stage",
  data() {
    return {
      freelanceJob:
        this.$store.state.client.clientData.type === 1 ? true : false,
      isFreelanceJob: false,
      contractJob:
        this.$store.state.client.clientData.type === 3 ? true : false,
      isContractJob: false,
      fulltimeJob:
        this.$store.state.client.clientData.type === 2 ? true : false,
      isFulltimeJob: false,
      crowdsourceJob:
        this.$store.state.client.clientData.type === 4 ? true : false,
      isCrowdsourceJob: false,
      curatedJob: this.$store.state.client.clientData.type === 5 ? true : false,
      isCuratedJob: false,
      type: this.$store.state.client.clientData.type,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    next() {
      const { type } = this;
      this.$store.commit("client/updateClient", {
        type,
      });
      this.$store.commit("fcjob/updateFcJob", {
        type,
      });

      if (this.freelanceJob) {
        this.$router.push("hire/fc");
      } else if (this.crowdsourceJob) {
        this.$router.push("hire/fc");
      } else if (this.fulltimeJob) {
        this.$router.push("hire/job-post");
      } else if (this.contractJob) {
        this.$router.push("hire/job-post");
      } else if (this.curatedJob) {
        this.$router.push("hire/job-post");
      }
    },
    clickedFreelanceJob() {
      this.type = 1;
      this.freelanceJob = true;
      this.isFreelanceJob = true;
      this.contractJob = false;
      this.isContractJob = false;
      this.fulltimeJob = false;
      this.isFulltimeJob = false;
      this.crowdsourceJob = false;
      this.isCrowdsourceJob = false;
      this.curatedJob = false;
      this.isCuratedJob = false;
    },
    clickedContractJob() {
      this.type = 3;
      this.contractJob = true;
      this.isContractJob = true;
      this.freelanceJob = false;
      this.isFreelanceJob = false;
      this.fulltimeJob = false;
      this.isFulltimeJob = false;
      this.crowdsourceJob = false;
      this.isCrowdsourceJob = false;
      this.curatedJob = false;
      this.isCuratedJob = false;
    },
    clickedFulltimeJob() {
      this.type = 2;
      this.fulltimeJob = true;
      this.isFulltimeJob = true;
      this.freelanceJob = false;
      this.isFreelanceJob = false;
      this.contractJob = false;
      this.isContractJob = false;
      this.crowdsourceJob = false;
      this.isCrowdsourceJob = false;
      this.curatedJob = false;
      this.isCuratedJob = false;
    },
    clickedCrowdsourceJob() {
      this.type = 4;
      this.crowdsourceJob = true;
      this.isCrowdsourceJob = true;
      this.freelanceJob = false;
      this.isFreelanceJob = false;
      this.contractJob = false;
      this.isContractJob = false;
      this.fulltimeJob = false;
      this.isFulltimeJob = false;
      this.curatedJob = false;
      this.isCuratedJob = false;
    },
    clickedCuratedJob() {
      this.type = 5;
      this.curatedJob = true;
      this.isCuratedJob = true;
      this.crowdsourceJob = false;
      this.isCrowdsourceJob = false;
      this.freelanceJob = false;
      this.isFreelanceJob = false;
      this.contractJob = false;
      this.isContractJob = false;
      this.fulltimeJob = false;
      this.isFulltimeJob = false;
    },
  },
};
</script>
<style scoped>
.control-width {
  width: 600px;
}
.stage-box {
  height: 90px;
  width: 180px;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}
.stage-box:hover {
  background-color: #f1f1f1;
}
.checked {
  position: absolute;
  left: 190px;
  font-size: 35px;
  bottom: 45px;
  color: #4bb38e;
}
@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
  .control-width {
    width: 500px;
  }
}
@media (max-width: 550px) {
  .control-width {
    width: 98%;
  }
  .stage-box {
    height: 75px;
    width: 140px;
    border-radius: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  }
  .checked {
    position: absolute;
    left: 135px;
    font-size: 30px;
    bottom: 45px;
    color: #4bb38e;
  }
}
</style>
